import React from "react";
import { Link } from "react-router-dom";
import {
  MapIcon,
  TruckIcon,
  FaceSmileIcon,
  ChevronRightIcon,
} from "@heroicons/react/24/outline";

const ServicesOverview: React.FC = () => {
  const services = [
    {
      title: "Tour Packages",
      description:
        "Customised itineraries tailored to your interests, budget, and schedule. Let us guide you to iconic destinations, or incorporate your specific must see locations into the perfect journey.",
      icon: <MapIcon className="w-8 h-8" />,
      link: "/tours",
    },
    {
      title: "Vehicle and Motorhome Rentals",
      description:
        "Quality vehicles for every need - from compact cars to luxury motorhomes. Explore New Zealand at your own pace with our fleet.",
      icon: <TruckIcon className="w-8 h-8" />,
      link: "/vehicles",
    },
    {
      title: "Activity Bookings",
      description:
        "Access to New Zealand's best activities and experiences with competitive prices. From bungy jumping to cultural tours, we book your adventures with trusted operators.",
      icon: <FaceSmileIcon className="w-8 h-8" />,
      link: "/activities",
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
            Our Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            One stop centre for New Zealand travel solutions
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-gray-50 p-6 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 group"
            >
              <div className="text-primary mb-4 group-hover:scale-110 transition-transform duration-300">
                {service.icon}
              </div>
              <h3 className="text-xl font-semibold text-primaryText mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 mb-4">{service.description}</p>
              <Link
                to={service.link}
                className="inline-flex items-center text-primaryText font-semibold hover:text-primary transition-colors duration-300"
              >
                Learn More
                <ChevronRightIcon className="w-4 h-4 ml-1" />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;
